import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Loader2, MailCheck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email }, { withCredentials: true });
    } catch {
      // always show the same message
    } finally {
      setSent(true);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F172A] noise-overlay flex items-center justify-center px-4" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" data-testid="forgot-logo-link">
            <img src="/assets/aegis-logo-dark.webp" alt="Aegis Subsurface LLC logo" className="h-24 w-auto inline-block" />
          </Link>
          <h1 className="mt-6 font-heading text-2xl font-black uppercase tracking-tight text-white" data-testid="forgot-heading">
            Reset Password
          </h1>
          <p className="mt-2 text-sm text-slate-400">We'll email you a reset link</p>
        </div>

        <div className="bg-white rounded-sm p-8 border border-slate-200">
          {sent ? (
            <div className="text-center" data-testid="forgot-success">
              <MailCheck className="w-10 h-10 text-[#FF5A00] mx-auto" />
              <p className="mt-4 text-base text-slate-700 leading-relaxed">
                If an account exists for <strong>{email}</strong>, a password reset link is on its way. It expires in 1 hour.
              </p>
              <Link to="/login" className="mt-6 inline-block text-sm font-semibold text-[#FF5A00] hover:text-[#E04F00]" data-testid="forgot-back-to-login">
                Back to login
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} data-testid="forgot-form">
              <label htmlFor="forgot-email" className="block text-xs font-bold uppercase tracking-wider text-[#0F172A] mb-2">
                Email
              </label>
              <input
                id="forgot-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-white border border-slate-300 rounded-sm px-4 py-3 text-base text-[#0F172A] placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#FF5A00] focus:border-[#FF5A00] transition-shadow duration-200"
                placeholder="you@example.com"
                data-testid="forgot-email-input"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="forgot-submit-button"
                className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-[#FF5A00] hover:bg-[#E04F00] disabled:opacity-60 text-white font-heading font-bold uppercase tracking-wider px-8 py-3.5 rounded-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[4px_4px_0px_#0F172A]"
              >
                {loading && <Loader2 className="w-5 h-5 animate-spin" />}
                {loading ? "Sending..." : "Send Reset Link"}
              </button>
              <p className="mt-5 text-center text-sm">
                <Link to="/login" className="text-slate-500 hover:text-[#FF5A00] transition-colors" data-testid="forgot-cancel-link">
                  Back to login
                </Link>
              </p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
